// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card__TrialPanel-module--WuGie {
    display: flex;
    flex-direction: column;
    gap: var(--space-md);
    height: 100%;
    padding: var(--space-lg);
    border-radius: var(--home-radius-3xl);
    /* A brand theme can give the card its own colour (brandThemes.module.css), e.g. LANTITE's teal. */
    background: var(--home-trial-bg, var(--home-color-orange));
    color: var(--color-text-primary);
}

.eyebrow__TrialPanel-module--zCzye {
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.heading__TrialPanel-module--cYa07 {
    margin: 0;
    font-size: var(--home-text-heading);
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1;
}

.body__TrialPanel-module--tZTyA {
    margin: 0;
    font-size: 17px;
    line-height: 1.6;
}

.form__TrialPanel-module--tihtB {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
    margin-top: auto;
}

.fieldLabel__TrialPanel-module--GjDJ_ {
    font-weight: 600;
}

.row__TrialPanel-module--aPzu0 {
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-xs);
}

.row__TrialPanel-module--aPzu0 > :first-child {
    flex: 1 1 220px;
    min-width: 0;
}

.submitButton__TrialPanel-module--w46Tn {
    flex-shrink: 0;
}

.alert__TrialPanel-module--RWYPZ {
    margin: 0;
}

/* A trial asked for through a sales representative: one block per region (Cambridge LANTITE Edge's lecturers). */
/* Doubled to outrank styles.css, whose list rules put the bullets back. */
.contacts__TrialPanel-module--Lf25i.contacts__TrialPanel-module--Lf25i {
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
    margin: 0;
    padding: 0;
    list-style: none;
}

.contacts__TrialPanel-module--Lf25i.contacts__TrialPanel-module--Lf25i li {
    margin: 0;
    list-style: none;
}

.contactRegion__TrialPanel-module--fwCsc {
    margin: 0 0 var(--space-3xs);
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
}

.contactLine__TrialPanel-module--MOmbr {
    margin: 0;
    font-size: 15px;
    line-height: 1.5;
}

.contactLine__TrialPanel-module--MOmbr a {
    color: inherit;
    text-decoration: underline;
}

.hint__TrialPanel-module--sNj0o {
    margin: 0;
    font-size: 14px;
    line-height: 1.55;
}
`, "",{"version":3,"sources":["webpack://./src/main/ui/home/components/TrialPanel.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,YAAY;IACZ,wBAAwB;IACxB,qCAAqC;IACrC,kGAAkG;IAClG,0DAA0D;IAC1D,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,SAAS;AACb;;AAEA,iHAAiH;AACjH,0EAA0E;AAC1E;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB","sourcesContent":[".card {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-md);\n    height: 100%;\n    padding: var(--space-lg);\n    border-radius: var(--home-radius-3xl);\n    /* A brand theme can give the card its own colour (brandThemes.module.css), e.g. LANTITE's teal. */\n    background: var(--home-trial-bg, var(--home-color-orange));\n    color: var(--color-text-primary);\n}\n\n.eyebrow {\n    font-size: 13px;\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n}\n\n.heading {\n    margin: 0;\n    font-size: var(--home-text-heading);\n    font-weight: 800;\n    letter-spacing: -0.02em;\n    line-height: 1;\n}\n\n.body {\n    margin: 0;\n    font-size: 17px;\n    line-height: 1.6;\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-2xs);\n    margin-top: auto;\n}\n\n.fieldLabel {\n    font-weight: 600;\n}\n\n.row {\n    display: flex;\n    flex-wrap: wrap;\n    gap: var(--space-xs);\n}\n\n.row > :first-child {\n    flex: 1 1 220px;\n    min-width: 0;\n}\n\n.submitButton {\n    flex-shrink: 0;\n}\n\n.alert {\n    margin: 0;\n}\n\n/* A trial asked for through a sales representative: one block per region (Cambridge LANTITE Edge's lecturers). */\n/* Doubled to outrank styles.css, whose list rules put the bullets back. */\n.contacts.contacts {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    margin: 0;\n    padding: 0;\n    list-style: none;\n}\n\n.contacts.contacts li {\n    margin: 0;\n    list-style: none;\n}\n\n.contactRegion {\n    margin: 0 0 var(--space-3xs);\n    font-size: 14px;\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-transform: uppercase;\n}\n\n.contactLine {\n    margin: 0;\n    font-size: 15px;\n    line-height: 1.5;\n}\n\n.contactLine a {\n    color: inherit;\n    text-decoration: underline;\n}\n\n.hint {\n    margin: 0;\n    font-size: 14px;\n    line-height: 1.55;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `card__TrialPanel-module--WuGie`,
	"eyebrow": `eyebrow__TrialPanel-module--zCzye`,
	"heading": `heading__TrialPanel-module--cYa07`,
	"body": `body__TrialPanel-module--tZTyA`,
	"form": `form__TrialPanel-module--tihtB`,
	"fieldLabel": `fieldLabel__TrialPanel-module--GjDJ_`,
	"row": `row__TrialPanel-module--aPzu0`,
	"submitButton": `submitButton__TrialPanel-module--w46Tn`,
	"alert": `alert__TrialPanel-module--RWYPZ`,
	"contacts": `contacts__TrialPanel-module--Lf25i`,
	"contactRegion": `contactRegion__TrialPanel-module--fwCsc`,
	"contactLine": `contactLine__TrialPanel-module--MOmbr`,
	"hint": `hint__TrialPanel-module--sNj0o`
};
export default ___CSS_LOADER_EXPORT___;
